export const useHiddenAssets = () => {
    const isAssetsShown = window.localStorage.getItem('showAssetsBalance') === 'true';

    const toggleIsAssetsHidden = () => {
        window.localStorage.setItem('showAssetsBalance', String(!isAssetsShown));
    };
    return { toggleIsAssetsHidden, isAssetsHidden: !isAssetsShown };
};
